import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MessageSquare } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import api from '@/utils/api';

export default function MessagesNavButton() {
  const navigate = useNavigate();
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let mounted = true;
    const fetchUnread = async () => {
      try {
        const res = await api.get('/messages/unread-count');
        if (mounted) setUnread(res.data?.unread_count ?? res.data?.count ?? 0);
      } catch (e) { console.debug('Unread count poll failed', e?.response?.status); }
    };
    fetchUnread();
    const id = setInterval(fetchUnread, 30000);
    return () => { mounted = false; clearInterval(id); };
  }, []);

  return (
    <Button
      onClick={() => navigate('/messages')}
      variant="ghost"
      className="relative text-zinc-400 hover:text-white"
      data-testid="messages-nav-button"
    >
      <MessageSquare className="w-4 h-4 mr-2" />
      Messages
      {unread > 0 && (
        <Badge
          className="absolute -top-1 -right-1 bg-primary-neon text-black border-0 text-[10px] px-1.5 h-5 min-w-[20px] flex items-center justify-center"
          data-testid="messages-unread-badge"
        >
          {unread > 99 ? '99+' : unread}
        </Badge>
      )}
    </Button>
  );
}
